<template>
    <common-dropdown :isOpen="isOpen" arrowPositionY="top" arrowPositionX="left">
        <section class="appointment-calendar-slots">
            <common-loader :isProcessing="isSending"></common-loader>

            <template>
                <header class="appointment-calendar-slots__header">
                    <common-date
                        :date="date"
                        :copy="$tc('pages.referrals.new.steps.schedule.referrals', referralsCount)"
                    ></common-date>
                </header>

                <div ref="options" class="availability-calendar-day-slot" @scroll.passive="toggleReferralContextMenu">
                    <section class="availability-month-calendar-slots__group">
                        <h5 class="appointment-calendar-slots__time-of-day">
                            {{ $t('pages.referrals.new.steps.schedule.am') }}
                        </h5>

                        <calendar-slot
                            dayPeriod="am"
                            :showCancelled="showCancelled"
                            :options="amOptions"
                            :presentedContextMenuKey="currentlyOpenContextMenu"
                            @toggleSlot="toggleReferralContextMenu($event)"
                            @schedule-changed="emitEvent({ name: 'schedule-changed' })"
                        ></calendar-slot>
                    </section>

                    <section class="availability-month-calendar-slots__group">
                        <h5 class="appointment-calendar-slots__time-of-day">
                            {{ $t('pages.referrals.new.steps.schedule.pm') }}
                        </h5>
                        <calendar-slot
                            dayPeriod="pm"
                            :showCancelled="showCancelled"
                            :options="pmOptions"
                            :presentedContextMenuKey="currentlyOpenContextMenu"
                            @toggleSlot="toggleReferralContextMenu($event)"
                            @schedule-changed="emitEvent({ name: 'schedule-changed' })"
                        ></calendar-slot>
                    </section>
                </div>

                <footer class="appointment-calendar-slots__footer"></footer>
            </template>
        </section>
    </common-dropdown>
</template>

<script>
    import CalendarSlotsMixin from 'mixins/CalendarSlotsMixin'
    import ReferralContextMenuMixin from 'mixins/ReferralContextMenuMixin'
    import CalendarSlot from './AvailabilityMonthCalendarSlot'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [CalendarSlotsMixin, ReferralContextMenuMixin, ScreenSizeDetectionMixin],

        components: {
            CalendarSlot,
        },

        props: {
            slots: { type: Array, required: true },
            referralsCount: { type: Number, required: true },
            showCancelled: { type: Boolean, required: true },
        },

        computed: {
            amOptions() {
                return this.slots
                    .filter((slot) => slot.startTime.split(':')[0] < 12)
                    .map((slot) => ({
                        label: [slot.startTime, slot.endTime].join(' - '),
                        value: slot,
                    }))
            },
            pmOptions() {
                return this.slots
                    .filter((slot) => slot.startTime.split(':')[0] >= 12)
                    .map((slot) => ({
                        label: [slot.startTime, slot.endTime].join(' - '),
                        value: slot,
                    }))
            },
        },

        watch: {
            isOpen() {
                if (!this.isOpen) {
                    this.currentlyOpenContextMenu = undefined
                    return
                }
                this.indicateScrollability()
            },
        },
    }
</script>
